import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import {
	AppBar,
	Toolbar,
	makeStyles,
	Box,
} from '@material-ui/core';
import Title from './Title';
import MobileMenu from './MobileMenu';
import BackButton from './BackButton';
import Communications from './Communications';

const useStyles = makeStyles((theme) => ({
	root: {
		zIndex: theme.zIndex.drawer + 100
	},
	toolbar: {
		minHeight: 64
	},
	logo: {
		width: "100%",
		height: "100%",
		maxWidth: 200
	}
}));

function TopBar({
	className,
	onMobileNavOpen,
	...rest
}) {
	const classes = useStyles();

	return (
		<AppBar
			className={clsx(classes.root, className)}
			{...rest}
		>
			<Toolbar className={classes.toolbar}>
				<BackButton />
				<Box
					ml={2}
					flexGrow={1}
				/>

				<Communications />
				
				<Box ml={2}>
					<MobileMenu onMobileNavOpen={onMobileNavOpen} />
				</Box>
				</Toolbar>
			<Title/>
		</AppBar>
	);
}

TopBar.propTypes = {
	className: PropTypes.string,
	onMobileNavOpen: PropTypes.func
};

export default TopBar;
